import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
// CUSTOM COLORS
import { zuiBlue } from './colors/zuiBlue';
import { zuiGray } from './colors/zuiGray';
import { zuiOrange } from './colors/zuiOrange';

const theme = createTheme({
  /* theme for mui v5.x */
  typography: {
    useNextVariants: true,
    fontSize: 11.4, // equates to 13px on a standard browser setup - see https://material-ui.com/customization/themes/#typography
    fontFamily: 'inherit !important', // Use the fonts from zui.css instead of Roboto
  },
  palette: {
    primary: zuiBlue,
    secondary: zuiOrange,
    error: red,
    text: {
      // primary: '#666666',
      // secondary: '#999999',
    },
    background: {
      default: '#FAFAFA', // used as background to some tables
    },
  },
  components: {
    MuiExpansionPanelDetails: {
      styleOverrides: {
        root: {
          padding: '8px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        // Name of the component ⚛️ / style sheet
        root: {
          // Name of the rule
          color: '#b3b3b3', // make label color alpha 0.87 to be compatible with previous version
        },
        shrink: {
          fontSize: 16, // make the shrink input label larger than standard
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        wrapper: {
          WebkitTextFillColor: 'initial', //#804 - fixes safaris
        },
        fullWidth: {
          fontSize: 13,
          backgroundColor: zuiGray[50],
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontSize: 13,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        label: {
          WebkitTextFillColor: 'initial', //#804 - fixes safari
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        message: {
          WebkitTextFillColor: 'initial',
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          backgroundColor: '#fff',
          border: '2px solid currentColor',
          height: '14px',
          width: '14px',
          '&.Mui-disabled': {
            height: '14px',
            width: '14px',
          },
        },
        active: {},
        mark: {
          backgroundColor: '#fff',
          border: '2px solid #e9e9e9',
          height: 4,
          width: 4,
          borderRadius: '50%',
        },
        markActive: {
          backgroundColor: '#fff',
          border: '2px solid currentColor',
        },
        markLabel: {
          fontSize: 12,
          color: '#666',
        },
        track: {
          height: 4,
          borderRadius: 4,
          border: 0,
        },
        rail: {
          height: 4,
          borderRadius: 4,
          opacity: 1,
          backgroundColor: '#e9e9e9',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1.5rem',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          WebkitTextFillColor: 'initial', //#804 - fixes safari
        },
        body1: {
          fontSize: 13,
          fontWeight: 'normal',
          fontStyle: 'normal',
          color: '#666666',
        },
        body2: {
          fontSize: 13,
          fontWeight: 'normal',
          fontStyle: 'italic',
          color: '#666666',
        },
        button: {
          fontSize: 14,
          fontWeight: 500,
          color: '#666666',
          textTransform: 'capitalize',
        },
        h1: {
          fontSize: 21,
          fontWeight: 500,
          color: '#FFFFFF',
        },
        h2: {
          fontSize: 20,
          fontWeight: 700,
          color: '#666666',
        },
        h3: {
          fontSize: 14,
          fontWeight: 'bold',
          color: '#666666',
        },
        h4: {
          fontSize: 13,
          fontWeight: 'bold',
          fontStyle: 'italic',
          color: '#666666',
        },
        h5: {
          fontSize: 13,
          fontWeight: 'bold',
          color: '#666666',
        },
        h6: {
          fontSize: 13,
          fontWeight: 'bold',
          fontStyle: 'italic',
          color: '#666666',
        },
      },
    },
  },
});

export default theme;
